import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ButtonGroup, Col, Container, Row, ToggleButton } from "react-bootstrap";
import { textFilter } from "react-bootstrap-table2-filter";
import Button from "react-bootstrap/Button";
import { withTranslation } from "react-i18next";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import StorageService from "../../../../services/StorageService";
import AllowedUrlsActionCell from "./allowedUrlsActionCell/AllowedUrlsActionCell";
import AddAllowedUrlDialog from "./dialogs/addAllowedUrlDialog/AddAllowedUrlDialog";
import DeleteAllowedUrlDialog from "./dialogs/deleteAllowedUrlDialog/DeleteAllowedUrlDialog";

class AllowedUrlsTab extends React.Component {
  tableId = "allowedUrlsTabTable";
  constructor(props) {
    super(props);
    let showFilters = StorageService.getTableConfigValue(this.tableId, "showFilters");
    this.state = {
      allowedUrls: this.props.networkProfile.proxyUrls,
      apiError: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      showAddAllowedUrlModal: false,
      showDeleteAllowedUrlModal: false
    };

    this.handleDeleteAllowedUrl = this.handleDeleteAllowedUrl.bind(this);
    this.handleAddAllowedUrl = this.handleAddAllowedUrl.bind(this);
  }

  async handleAddAllowedUrl(url) {
    const networkProfile = Object.assign({}, this.props.networkProfile);
    networkProfile["proxyUrls"] = [
      ...new Set([...this.props.networkProfile.proxyUrls, url])
    ];
    if (this.props.onSubmit(networkProfile))
      this.setState({ showAddAllowedUrlModal: false });
  }

  async handleDeleteAllowedUrl() {
    const networkProfile = Object.assign({}, this.props.networkProfile);
    networkProfile["proxyUrls"] = [
      ...new Set(
        this.props.networkProfile.proxyUrls.filter(
          u => u !== this.state.selectedUrl
        )
      )
    ];
    if (this.props.onSubmit(networkProfile))
      this.setState({ showDeleteAllowedUrlModal: false });
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "url",
        text: t("SingleNetworkProfile.AllowedUrlsTab.ColumnUrl"),
        sort: true,
        filter: textFilter({
          placeholder: t(
            "SingleNetworkProfile.AllowedUrlsTab.FilterUrlPlaceholder"
          ),
          style: { display: this.state.displayFilter }
        })
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup
            toggle
            style={{ float: "right", marginRight: "-12px" }}
          >
            <ToggleButton
              type="checkbox"
              value={1}
              className="btn-green btn-sm"
              checked={this.state.showFilters}
              onChange={e => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none"
                });
                StorageService.setTableConfigValue(this.tableId, "showFilters", e.currentTarget.checked);
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, row) => (
          <AllowedUrlsActionCell
            onDelete={() =>
              this.setState({
                showDeleteAllowedUrlModal: true,
                selectedUrl: row.url
              })
            }
          />
        )
      }
    ];

    return (
      <div>
        <DeleteAllowedUrlDialog
          show={this.state.showDeleteAllowedUrlModal}
          dialogApiError={this.props.dialogApiError}
          onHide={() => this.setState({ showDeleteAllowedUrlModal: false })}
          onSubmit={this.handleDeleteAllowedUrl}
        />
        <AddAllowedUrlDialog
          show={this.state.showAddAllowedUrlModal}
          dialogApiError={this.props.dialogApiError}
          onHide={() => this.setState({ showAddAllowedUrlModal: false })}
          onSubmit={this.handleAddAllowedUrl}
        />
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="mt-3">
            <Col>
              <h4>{t("SingleNetworkProfile.AllowedUrlsTab.Title")}</h4>
            </Col>
            <Col>
              <Button
                className="btn btn-green"
                style={{ float: "right" }}
                onClick={() => this.setState({ showAddAllowedUrlModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <PaginationTable
                data={this.props.networkProfile.proxyUrls.map(p => ({ url: p }))}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="url"
                id={this.tableId}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(AllowedUrlsTab);
